import React from 'react';
import { WashingMachine, Tv, Refrigerator, Fan, Coffee } from 'lucide-react';
export const ServiceCoverage = () => {
  return <div className="bg-white" data-id="element-577">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-578">
        <div className="text-center" data-id="element-579">
          <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-580">
            Service Coverage
          </h1>
          <p className="mt-4 text-xl text-gray-500 max-w-3xl mx-auto" data-id="element-581">
            Comprehensive information about our appliance repair and maintenance
            services across the UK.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-2" data-id="element-582">
          <div className="bg-rose-50 rounded-lg overflow-hidden shadow-lg" data-id="element-583">
            <div className="px-6 py-8" data-id="element-584">
              <h2 className="text-2xl font-bold text-rose-900 mb-4" data-id="element-585">
                Covered Appliances
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-6" data-id="element-586">
                <div className="flex flex-col items-center" data-id="element-587">
                  <div className="bg-rose-100 p-3 rounded-full" data-id="element-588">
                    <WashingMachine className="h-8 w-8 text-rose-900" data-id="element-589" />
                  </div>
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-590">
                    Washing Machines
                  </span>
                </div>
                <div className="flex flex-col items-center" data-id="element-591">
                  <div className="bg-rose-100 p-3 rounded-full" data-id="element-592">
                    <Tv className="h-8 w-8 text-rose-900" data-id="element-593" />
                  </div>
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-594">
                    Televisions
                  </span>
                </div>
                <div className="flex flex-col items-center" data-id="element-595">
                  <div className="bg-rose-100 p-3 rounded-full" data-id="element-596">
                    <Refrigerator className="h-8 w-8 text-rose-900" data-id="element-597" />
                  </div>
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-598">
                    Refrigerators
                  </span>
                </div>
                <div className="flex flex-col items-center" data-id="element-599">
                  <div className="bg-rose-100 p-3 rounded-full" data-id="element-600">
                    <div className="h-8 w-8 text-rose-900" data-id="element-601" />
                  </div>
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-602">
                    Ovens & Cookers
                  </span>
                </div>
                <div className="flex flex-col items-center" data-id="element-603">
                  <div className="bg-rose-100 p-3 rounded-full" data-id="element-604">
                    <Fan className="h-8 w-8 text-rose-900" data-id="element-605" />
                  </div>
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-606">
                    Fans & Air Con
                  </span>
                </div>
                <div className="flex flex-col items-center" data-id="element-607">
                  <div className="bg-rose-100 p-3 rounded-full" data-id="element-608">
                    <Coffee className="h-8 w-8 text-rose-900" data-id="element-609" />
                  </div>
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-610">
                    Small Appliances
                  </span>
                </div>
              </div>
              <p className="mt-6 text-gray-600" data-id="element-611">
                Our skilled technicians are trained to repair and maintain a
                wide range of household appliances from all major brands. If you
                don't see your specific appliance listed, please contact us to
                check if we can help.
              </p>
            </div>
          </div>
          <div className="bg-gray-50 rounded-lg overflow-hidden shadow-lg" data-id="element-612">
            <div className="px-6 py-8" data-id="element-613">
              <h2 className="text-2xl font-bold text-rose-900 mb-4" data-id="element-614">
                Service Area
              </h2>
              <p className="text-gray-600 mb-4" data-id="element-615">
                We currently provide services across mainland UK postcodes. For
                remote areas, response times may be longer. Please contact us to
                confirm if your location is covered.
              </p>
              <div className="mt-6" data-id="element-616">
                <img src="https://images.unsplash.com/photo-1577553696425-6a0654d2c122?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="UK Map" className="w-full h-64 object-cover rounded-md" data-id="element-617" />
              </div>
              <p className="mt-6 text-gray-600" data-id="element-618">
                We aim to schedule engineer visits within 24 to 48 hours,
                excluding weekends and public holidays. For urgent repairs,
                please call our customer service line directly.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-12 bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-619">
          <div className="px-6 py-8" data-id="element-620">
            <h2 className="text-2xl font-bold text-rose-900 mb-6" data-id="element-621">
              Service Activation & Coverage Details
            </h2>
            <div className="space-y-8" data-id="element-622">
              <div data-id="element-623">
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-624">
                  Service Activation & Start Date
                </h3>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-625">
                  <p className="text-gray-600 mb-4" data-id="element-626">
                    <span className="font-medium" data-id="element-627">
                      When does my cover begin?
                    </span>{' '}
                    Your protection starts immediately once your payment is
                    processed. You will receive a confirmation email shortly
                    afterwards.
                  </p>
                  <p className="text-gray-600 mb-4" data-id="element-628">
                    <span className="font-medium" data-id="element-629">
                      Do I need to take any steps to activate my plan?
                    </span>{' '}
                    No, activation happens automatically. Your plan begins as
                    soon as your purchase is complete and remains valid for 12
                    months.
                  </p>
                  <p className="text-gray-600" data-id="element-630">
                    <span className="font-medium" data-id="element-631">
                      When does my coverage end?
                    </span>{' '}
                    Your plan expires exactly 12 months later at 23:59 on the
                    final day, unless you renew it beforehand.
                  </p>
                </div>
              </div>
              <div data-id="element-632">
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-633">
                  How Do I Request a Repair?
                </h3>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-634">
                  <p className="text-gray-600 mb-4" data-id="element-635">Please contact us by:</p>
                  <p className="text-gray-600 mb-2" data-id="element-636">📞 0800 055 4969</p>
                  <p className="text-gray-600 mb-4" data-id="element-637">
                    📧 angelene18inandan@gmail.com
                  </p>
                  <p className="text-gray-600" data-id="element-638">
                    Our team will organise your repair appointment, usually
                    within 24 to 48 hours.
                  </p>
                </div>
              </div>
              <div data-id="element-639">
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-640">
                  What's Included?
                </h3>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-641">
                  <ul className="list-disc list-inside space-y-2 text-gray-600" data-id="element-642">
                    <li data-id="element-643">
                      Unlimited repair visits and callouts for appliances
                      covered during your 12-month plan
                    </li>
                    <li data-id="element-644">All labour costs are covered</li>
                    <li data-id="element-645">Replacement parts provided when available</li>
                    <li data-id="element-646">
                      Engineer appointments are generally booked within 24–48
                      hours after reporting a fault
                    </li>
                    <li data-id="element-647">Coverage includes mechanical and electrical faults</li>
                  </ul>
                </div>
              </div>
              <div data-id="element-648">
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-649">
                  What's Not Covered?
                </h3>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-650">
                  <ul className="list-disc list-inside space-y-2 text-gray-600" data-id="element-651">
                    <li data-id="element-652">
                      Cosmetic damage or normal wear and tear of appliances
                    </li>
                    <li data-id="element-653">Faults that existed prior to your plan start date</li>
                    <li data-id="element-654">Damage caused by misuse or unauthorised repairs</li>
                    <li data-id="element-655">
                      Appliances older than 10 years at the start of your plan
                    </li>
                    <li data-id="element-656">
                      Damage due to floods, fires, or other natural disasters
                    </li>
                  </ul>
                </div>
              </div>
              <div data-id="element-657">
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-658">
                  Plan Exclusions & Prohibited Use
                </h3>
                <div className="bg-gray-50 p-4 rounded-md" data-id="element-659">
                  <p className="text-gray-600 mb-4" data-id="element-660">
                    To ensure fair use and maintain service quality, the
                    following are excluded from cover:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-600" data-id="element-661">
                    <li data-id="element-662">Damage or faults existing before your plan started</li>
                    <li data-id="element-663">Damage caused by neglect, misuse, or tampering</li>
                    <li data-id="element-664">Repairs unrelated to normal appliance operation</li>
                    <li data-id="element-665">
                      Any illegal or fraudulent use of our services or website
                    </li>
                    <li data-id="element-666">
                      Appliances used contrary to manufacturer instructions
                    </li>
                  </ul>
                  <p className="text-gray-600 mt-4" data-id="element-667">
                    Please note: If any of these exclusions apply, your plan may
                    be cancelled without refund or further support.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};